import React from 'react';
import './DatePills.css';

/**
 * Horizontal scrollable strip of date pills.
 *
 * @param {Array} dates    [{ iso, dow, day, month }]
 * @param {string} value   currently-selected ISO date
 * @param {fn} onChange    (iso) => void
 * @param {boolean} loading
 */
export default function DatePills({ dates = [], value, onChange, loading }) {
  if (loading) {
    return (
      <div className="date-pills" aria-busy="true">
        {Array.from({ length: 8 }).map((_, i) => (
          <div key={i} className="date-pill date-pill--skeleton" aria-hidden="true" />
        ))}
      </div>
    );
  }

  if (!dates.length) {
    return <div className="date-pills__empty">No dates available right now.</div>;
  }

  return (
    <div
      className="date-pills"
      role="radiogroup"
      aria-label="Available dates"
    >
      {dates.map((d) => {
        const selected = d.iso === value;
        return (
          <button
            key={d.iso}
            type="button"
            role="radio"
            aria-checked={selected}
            aria-label={`${d.dow} ${d.day} ${d.month}`}
            className={`date-pill ${selected ? 'date-pill--selected' : ''}`}
            onClick={() => onChange(d.iso)}
          >
            <span className="date-pill__dow">{d.dow}</span>
            <span className="date-pill__day">{d.day}</span>
            <span className="date-pill__month">{d.month}</span>
          </button>
        );
      })}
    </div>
  );
}